import { render, staticRenderFns } from "./OrgAuditDlg.vue?vue&type=template&id=3e384d37&scoped=true"
import script from "./OrgAuditDlg.vue?vue&type=script&lang=js"
export * from "./OrgAuditDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e384d37",
  null
  
)

export default component.exports